
export class MembershipModel {

    id: number;
    title: string;
    description: string;
    image: string;
    price: number;
    commission: number;
    total: number;
    days: number;
    period: string;
    recurring: boolean;
    date_added: Date;
    date_exp: Date = new Date();
    date_start: Date = new Date();
    currency: number;
    constructor(membership?: any) {

        if (membership) {
            this.id = membership.id;
            this.title = membership.title;
            this.description = membership.description;
            this.image = membership.image;
            this.price = membership.price;
            this.commission = membership.commission;
            this.total = membership.total;
            this.days = membership.days;
            this.period = membership.period;
            this.recurring = membership.recurring;
            this.date_added = membership.date_added;
            this.currency = membership.currency;
        }

    }

    public get isValid(): boolean {
        const today = new Date();
        return today < this.date_exp;
    }
}